import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { t } from '../common/LocalizationProvider';
import EditItemView from '../shared/EditItemView';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Typography,
  Box
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditAttributesView from '../attributes/EditAttributesView';
import deviceAttributes from '../attributes/deviceAttributes';
import SelectField from '../form/SelectField';

import { cyberStyles } from '../cssShared/cyberTheme';

const useStyles = makeStyles((theme) => ({
  ...cyberStyles(theme),
}));

const GroupPage = () => {
  const classes = useStyles();
  const [item, setItem] = useState();

  return (
      <EditItemView endpoint="groups" item={item} setItem={setItem}>
        {item &&
            <>
              {/* REQUIRED SECTION */}
              <Accordion defaultExpanded className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: '#00f2ff'}} />}>
                  <Typography className={classes.summaryText}>
                    {t('sharedRequired')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Box className={classes.fieldWrapper}>
                    <TextField
                        className={classes.neonInput}
                        fullWidth
                        value={item.name || ''}
                        onChange={event => setItem({...item, name: event.target.value})}
                        label={t('sharedName')}
                        variant="filled"
                    />
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* EXTRA SECTION */}
              <Accordion className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: '#00f2ff'}} />}>
                  <Typography className={classes.summaryText}>
                    {t('sharedExtra')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                    <SelectField
                        fullWidth
                        value={item.groupId || 0}
                        onChange={event => setItem({...item, groupId: Number(event.target.value)})}
                        endpoint="/api/groups"
                        label={t('groupParent')}
                        variant="filled"
                    />
                </AccordionDetails>
              </Accordion>

              {/* ATTRIBUTES SECTION */}
              <Accordion className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: '#00f2ff'}} />}>
                  <Typography className={classes.summaryText}>
                    {t('sharedAttributes')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <EditAttributesView
                      attributes={item.attributes}
                      setAttributes={attributes => setItem({...item, attributes})}
                      definitions={deviceAttributes}
                  />
                </AccordionDetails>
              </Accordion>
            </>
        }
      </EditItemView>
  );
}

export default GroupPage;